import property1 from "./assets/IMG-20250222-WA0032.jpg";
import apartment2 from "./assets/apartment2.jpg";
import apartment3 from "./assets/apartment3.jpg";
import apartment4 from "./assets/apartment4.jpg";
import Farm from "./assets/IMG-20250222-WA0046.jpg";
import villa2 from "./assets/IMG-20250222-WA0045.jpg";
import villa3 from "./assets/villa3.jpg";
import villa4 from "./assets/villa4.jpg";
import villa5 from "./assets/villa5.jpg";
import villa6 from "./assets/villa6.jpg";
import office1 from "./assets/office1.jpg";
import office2 from "./assets/office2.jpg";
import room1 from "./assets/IMG-20250222-WA0045.jpg";
import room2 from "./assets/IMG-20250222-WA0044.jpg";
import room3 from "./assets/IMG-20250222-WA0029.jpg";
import room4 from "./assets/IMG-20250222-WA0031.jpg";
import farm1 from "./assets/IMG-20250305-WA0014.jpg";
import farm2 from "./assets/IMG-20250305-WA0007.jpg";
import farm3 from "./assets/IMG-20250305-WA0009.jpg";
import farm4 from "./assets/IMG-20250305-WA0010.jpg";
import { IoBookOutline } from "react-icons/io5";
import { MdBalcony } from "react-icons/md";
import { FaLandmark, FaSpa, FaSwimmingPool } from "react-icons/fa";
import { TbAirConditioning, TbHanger, TbToolsKitchen3 } from "react-icons/tb";
import { LuPalmtree, LuParkingSquare } from "react-icons/lu";
import { PiSecurityCamera } from "react-icons/pi";
import { CgGym } from "react-icons/cg";

export const filterOptions = [
  {
    id: 1,
    title: "property type",
    options: ["residential", "commercial", "land", "industrial"],
  },
  {
    id: 2,
    title: "price limit",
    options: [
      "$1000",
      "$50,000",
      "$100,000",
      "$250,000",
      "$500,000",
      "$500,000+",
    ],
  },
  {
    id: 3,
    title: "Bedrooms",
    options: ["1 Bedroom", "2 Bedrooms", "3 Bedrooms", "3 Bedrooms+"],
  },
  {
    id: 4,
    title: "Bathrooms",
    options: ["1 Bathroom", "2 Bathrooms", "3 Bathrooms", "3 Bathrooms+"],
  },
  {
    id: 5,
    title: "Area Size (sqm)",
    options: ["100 (sqm)", "150 (sqm)", "175 (sqm)", "200 (sqm)", "200+ (sqm)"],
  },
];

export const properties = [
  {
    id: 1,
    title: "إيجار",
    image: property1,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "apartment",
    price: "$1500/month",
    bedrooms: 2,
    bathrooms: 1,
    size: 120,
  },
  {
    id: 2,
    title: "أُوكَازيُون",
    image: Farm,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "Farm",
    price: "$1,500,000",
    bedrooms: 5,
    bathrooms: 3,
    size: 796152,
  },
  {
    id: 3,
    title: "إيجار",
    image: villa2,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "villa",
    price: "$5000/month",
    bedrooms: 6,
    bathrooms: 3,
    size: 400,
  },
  {
    id: 4,
    title: "إيجار",
    image: office1,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "office",
    price: "$2500/month",
    bedrooms: 1,
    bathrooms: 1,
    size: 100,
  },
  {
    id: 5,
    title: "إيجار",
    image: apartment2,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "apartment",
    price: "$2000/month",
    bedrooms: 3,
    bathrooms: 1,
    size: 150,
  },
  {
    id: 6,
    title: "أُوكَازيُون",
    image: villa3,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "villa",
    price: "$2,000,000",
    bedrooms: 7,
    bathrooms: 3,
    size: 550,
  },
  {
    id: 7,
    title: "إيجار",
    image: villa4,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "villa",
    price: "$6000/month",
    bedrooms: 6,
    bathrooms: 3,
    size: 450,
  },
  {
    id: 8,
    title: "أُوكَازيُون",
    image: apartment3,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "apartment",
    price: "$750,000",
    bedrooms: 3,
    bathrooms: 2,
    size: 170,
  },
  {
    id: 9,
    title: "أُوكَازيُون",
    image: apartment4,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "apartment",
    price: "$800,000",
    bedrooms: 4,
    bathrooms: 2,
    size: 200,
  },
  {
    id: 10,
    title: "أُوكَازيُون",
    image: villa5,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "villa",
    price: "$2,500,000",
    bedrooms: 5,
    bathrooms: 3,
    size: 500,
  },
  {
    id: 11,
    title: "إيجار",
    image: villa6,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "villa",
    price: "$5500/month",
    bedrooms: 5,
    bathrooms: 2,
    size: 300,
  },
  {
    id: 12,
    title: "إيجار",
    image: office2,
    address: "36367 المنطقة الشرقية، السويدرة، الأحساء",
    type: "office",
    price: "4000/month",
    bedrooms: 1,
    bathrooms: 1,
    size: 120,
  },
];

export const propertyImages = [
  {
    id: 1,
    image: room1,
  },
  {
    id: 2,
    image: room2,
  },
  {
    id: 3,
    image: room3,
  },
  {
    id: 4,
    image: room4,
  },
 /* {
    id: 5,
    image: farm1,
  },
  {
    id: 6,
    image: farm2,
  },
  {
    id: 7,
    image: farm3,
  },
  {
    id: 8,
    image: farm4,
  },*/
];

 


export const amenities = [
  {
    id: 1,
    title: "Study",
   
  },
  {
    id: 2,
    title: "Balcony",
   
  },
  {
    id: 3,
    title: "Private Pool",
    
  },
  {
    id: 4,
    title: "Shared Spa",
   
  },
  {
    id: 5,
    title: "Covered Parking",
    
  },
  {
    id: 6,
    title: "Central A/C",
    
  },
  {
    id: 7,
    title: "Private Garden",
   
  },
  {
    id: 8,
    title: "Security",
   
  },
  {
    id: 9,
    title: "Built in Wardrobes",
   
  },
  {
    id: 10,
    title: "Kitchen Appliances",
  },
    
  {
    id: 11,
    title: "View of Landmark",
  
  },
  {
    id: 12,
    title: "Shared Gym",
   
  },
];
